export const projects = [
    {
        title: "Cereal Killers",
        subtitle: "Java, JavaFX, CSS, MySQL",
        description:
            "Cereal Killer is a JavaFX application that can be used to - keep a record of all the items in your Pantry with its expiration date. Get suggestions of recipes that can be prepared with pantry items that you have. See a detailed view of each recipe with all the ingredients and measure of each, cooking instructions and video of the recipe. Used to plan your meals a week ahead.",
        image: "./Project1_CerealKillers.png",
        link: "https://github.com/brian-patrao/CerealKiller",
    },
    {
        title: "Study Buddy",
        subtitle: "ReactJS, JavaScript, NodeJS, MongoDB, ExpressJS and SCSS",
        description:
            "Developed a full stack application as microservices, designed to streamline the studying process for students. This innovative tool offers a seamless user experience through two distinct login options. With the ability to effortlessly take notes and engage in subject-specific discussion forums, students can collaborate with peers and expert educators to resolve any academic queries. By simply entering the corresponding course code, students gain access to tailored discussion forums curated by their instructors for each subject.",
        image: "./Project2_StudyBuddy.png",
        link: "https://github.com/brian-patrao/StudyBuddy",
    },
    {
        title: "Library App",
        subtitle:
            "Java, Spring Boot, Hibernate, Bootstrap, TypeScript, ReactJS, MySQL and Okta(SSO)",
        description:
            "Developed a feature-rich library management application. The application empowers users to seamlessly view, borrow, and review books, for a seamless library experience. Includes SSO with okta",
        image: "./Project3_LibraryApp.png",
        link: "https://github.com/brian-patrao/LibraryApp",
    },
    {
        title: "Cloud Infrastructure and Application ",
        subtitle:
            "Java, Spring Boot, Hibernate, Terraform, Packer, GCP, Spring Security, MySQL",
        description:
            "Developed a Spring Boot Java application with a health endpoint for database connectivity checks and CRUD operations for users, deployed on GCP. Implemented CI/CD pipelines using GitHub Actions. Leveraged cloud function and Spring security to validate users. Utilized Terraform to provision and manage infrastructure, including VPC, subnets, security with IAM bindings, Cloud SQL, autoscaling, and Google Key Management. Leveraged Packer for creating application images for GCP deployment.",
        image: "./Project4_cloudapp.jpg",
        link: "https://github.com/brian-patrao/cloud-app",
    },
];

export const skills = [
    "JavaScript",
    "React",
    "Java",
    "Node.js",
    "PHP",
    "Ruby",
    "Ruby on Rails",
    "Groovy",
    "SpringBoot",
    "TypeScript",
    "Python",
    "HTML5",
    "CSS3",
    "SASS",
    "SCSS",
    "MySQL",
    "PostgreSQL",
    "MongoDB",
    "Docker",
    "PHPUnit",
    "Junit",
    "Mockito",
    "Git",
    "Spring Framework",
    "Zend Framework",
    "Spring Boot",
    "Terrform",
    "Packer",
    "Hibernate",
    "Linux",
    "ActiveMQ",
    "Camunda",
    "Camel",
    "Redis",
    "Express",
    "C#",
    "WPF",
    "WCF",
];



// WEBPACK FOOTER //
// ./src/data.js